<app-top-bar [topBarTitle]="topBarTitle"></app-top-bar>
<app-my-favorites-list></app-my-favorites-list>